<template>
  <section class="tw-bg-white tw-py-24">
    <div class="tw-container tw-mx-auto tw-px-6">
      <div class="tw-text-center tw-mb-16">
        <h2 class="tw-text-4xl md:tw-text-5xl tw-font-bold tw-text-gray-900 tw-mb-4 tw-leading-tight">
          We Work With Event Organizers Who Want Results
        </h2>
      </div>

      <div class="tw-max-w-6xl tw-mx-auto">
        <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-6 tw-mb-8">
          <!-- Card 1 -->
          <div class="tw-bg-gray-50 tw-p-6 tw-rounded-xl tw-border tw-border-gray-100 tw-text-center">
            <div class="tw-w-14 tw-h-14 tw-bg-primary-100 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-4">
              <svg class="tw-w-7 tw-h-7 tw-text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 class="tw-text-lg tw-font-semibold tw-text-gray-900 tw-mb-2">Export & Trade Show Organizers</h3>
            <p class="tw-text-gray-600 tw-text-sm tw-leading-relaxed">Large-scale B2B trade events and international exhibitions</p>
          </div>

          <!-- Card 2 -->
          <div class="tw-bg-gray-50 tw-p-6 tw-rounded-xl tw-border tw-border-gray-100 tw-text-center">
            <div class="tw-w-14 tw-h-14 tw-bg-primary-100 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-4">
              <svg class="tw-w-7 tw-h-7 tw-text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h3 class="tw-text-lg tw-font-semibold tw-text-gray-900 tw-mb-2">Industry Associations & Chambers</h3>
            <p class="tw-text-gray-600 tw-text-sm tw-leading-relaxed">Membership-driven events and networking conferences</p>
          </div>

          <!-- Card 3 -->
          <div class="tw-bg-gray-50 tw-p-6 tw-rounded-xl tw-border tw-border-gray-100 tw-text-center">
            <div class="tw-w-14 tw-h-14 tw-bg-primary-100 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-4">
              <svg class="tw-w-7 tw-h-7 tw-text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
            <h3 class="tw-text-lg tw-font-semibold tw-text-gray-900 tw-mb-2">Corporate Event Teams & Agencies</h3>
            <p class="tw-text-gray-600 tw-text-sm tw-leading-relaxed">Corporate events and agency-managed trade shows</p>
          </div>
        </div>

        <div class="tw-text-center">
          <p class="tw-text-gray-600 tw-text-base">
            Scales from <span class="tw-font-semibold tw-text-gray-900">200–5,000+</span> attendee events.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
